'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getExtraServices(reservationService, language, beginDate, endDate, destCode) {
    var request = reservationService.getExtraServices(language, beginDate, endDate, destCode);
    return request.then(function (result) {
        if (result) {
            return {
                state: 'ready',
                groups: processGroups(result.Transport)
            };
        } else {
            // It was canceled
            return null;
        }
    }, function (error) {
        console.error('[WinresTransport] Failed to get extra services:', error);
        return {
            state: 'error',
            groups: []
        };
    });
}

function processGroups(groups) {
    var visibleGroups = _.filter(groups, transportGroupIsVisible);

    return _.map(visibleGroups, function (group, i) {
        var visibleRoutes = _.filter(group.Items, productIsAvailable);
        var routes = _.map(visibleRoutes, routeToOption);

        // Add option for no transport for normal-linked (optional) transports
        if (!group.Force) {
            routes.splice(0, 0, ROUTE_NONE);
        }

        var onlyRouteOption = routes.length === 1 && !routes[0].disabled ? routes[0] : null;

        return {
            index: i,
            label: group.GroupName,
            routes: routes,
            onlyRouteOption: onlyRouteOption,
            available: routes.length > 0,
            freePlaces: _.sumBy(visibleRoutes, function (r) {
                return r.FreePlaces;
            }),

            // Just for display, not to be used for decisions in frontend
            id: group.GroupID,
            force: group.Force,
            guard: group.Guard
        };
    });
}

function transportGroupIsVisible(transportGroup) {
    return transportGroup.Blockers.length === 0 || transportGroup.Guard;
}

function productIsAvailable(product) {
    return product.Blockers.length === 0;
}

// Dummy "none of the above" route choice for optional (normal) transports
var ROUTE_NONE = {
    label: 'Ei kuljetusta',
    value: '- -',
    stops: []
};

var winresTransportController = function () {
    function winresTransportController($scope, $rootScope, reservationService, cancelService) {
        _classCallCheck(this, winresTransportController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.reservationService = reservationService;
        this.cancelService = cancelService;
    }

    _createClass(winresTransportController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Possible states:
            // initial - Starting state
            // loading - Loading new data
            // ready - Data loaded, ready to display
            // error - Something went wrong
            this.state = 'initial';

            // Pending request for data, so it can be canceled
            this.pending = null;

            // Passengers
            this.passengers = [];

            // Data to display
            this.groups = [];

            // Route options. Organized first by group index, then by passenger index.
            this.routeOptions = [];

            // Choices made
            this.choices = [];

            this.$scope.$watchGroup([function () {
                return _this.destCode;
            }, function () {
                return _this.beginDate;
            }, function () {
                return _this.endDate;
            }], function () {
                return _this.load(_this.destCode, _this.beginDate, _this.endDate);
            });

            // deep watch not required - wrapper always updates by assignment
            this.$scope.$watchCollection(function () {
                return [_this.inputPassengers, _this.inputProductLines];
            }, function () {
                _this.readPassengers(_this.inputPassengers);
                _this.readModel(_this.passengers, _this.groups, _this.inputProductLines);
            });

            this.$scope.$watch(function () {
                return [_this.choices, _this.isValid()];
            }, function () {
                _this.writeModel(_this.passengers, _this.groups, _this.choices);
                _this.updateRouteOptions(_this.passengers, _this.groups, _this.choices);
            }, true // deep
            );

            this.$scope.$on('winresReservationShowErrors', function () {
                return _this.error = true;
            });
        }
    }, {
        key: 'load',
        value: function load(destCode, beginDate, endDate) {
            var _this2 = this;

            if (this.pending) {
                this.cancelService.cancel(this.pending);
                this.pending = null;
            }

            if (!destCode || !beginDate || !endDate) {
                this.state = 'initial';
                return;
            } else {
                this.state = 'loading';
            }

            // console.log('[WinresTransport] Loading.', destCode, beginDate, endDate);

            var language = 'fi';

            var request = getExtraServices(this.reservationService, language, beginDate, endDate, destCode);
            this.pending = request;

            request.then(function (result) {
                if (!result) {
                    // Canceled promise.
                    return;
                } else if (request !== _this2.pending) {
                    console.log('[WinresTransport] Ignoring completed request because a newer one is pending.');
                    return;
                }
                _this2.state = result.state; // ready or error

                _this2.groups = result.groups;

                // This is to make shopping tabs know if there are any bus routes.
                _this2.broadcastShoppingTabsStatus();

                // console.log('[WinresTransport] Groups:', this.groups);
            }).catch(function (error) {
                // This error is unlikely since setting the component state is currently
                // trivial. Included anyway just to be sure.
                console.error('[WinresTransport] Failed to set component state:', error);
                _this2.state = 'error';
                _this2.groups = [];
            }).then(function () {
                if (_this2.pending === request) {
                    // The request that just completed was the most recent pending one.
                    _this2.pending = null;
                }
                _this2.readModel(_this2.passengers, _this2.groups, _this2.inputProductLines);
            });
        }
    }, {
        key: 'readPassengers',
        value: function readPassengers(passengers) {
            // console.log('[WinresTransport] Reading passengers.', passengers);
            this.passengers = _.flatMap(passengers, function (p, i) {
                var type = (p.Gender || 'MR').substring(0, 2);
                if (type === 'MR' || type === 'MS' || type === 'CH') {
                    return [{
                        index: i,
                        name: p.FirstName + ' ' + p.LastName
                    }];
                } else if (type === 'IN') {
                    return []; // No transport needed for infants
                } else {
                    console.warn('[WinresTransport] Unknown passenger type', p.Gender);
                    return []; // Ignore
                }
            });
            // console.log('[WinresTransport] Read passengers.', this.passengers);
        }
    }, {
        key: 'readModel',
        value: function readModel(passengers, groups, model) {
            var _this3 = this;

            var oldChoices = this.choices;

            this.initChoices();

            if (this.state !== 'ready') return;
            if (!model) return;

            // console.log('[WinresTransport] Reading model.', passengers, groups, model);

            _.forEach(model, function (line) {
                var routeValue = routeCodesToValue(line.DestinationCode, line.ProductCode);
                var group = _.find(groups, function (g) {
                    var route = findRoute(g, routeValue);
                    // Comment out debug log below once we find out what causes the error with "dates"
                    // console.log('[WinresTransport] Possible match for', routeValue, ':', route);

                    if (!route) {
                        // The route was not found in the group.
                        return false;
                    } else if (routeIsNone(routeValue)) {
                        // It's the "no transport" option, there are no dates to check.
                        return true;
                    } else {
                        // Check that the dates match.
                        return route.dates.begin.isSame(line.BeginDate, 'day') && route.dates.end.isSame(line.EndDate, 'day');
                    }
                });
                if (!group) {
                    console.warn('[WinresTransport] Could not find route', routeValue, line.BeginDate, line.EndDate);
                    return;
                }
                _.forEach(line.PassengerAssignments, function (pa) {
                    var passenger = passengers.find(function (p) {
                        return p.index === pa.PassengerNumber;
                    });
                    if (!passenger) {
                        console.warn('[WinresTransport] Could not find passenger', pa.PassengerNumber);
                        return;
                    }
                    var route = findRoute(group, routeValue);
                    var stop = routeIsNone(routeValue) ? null : route && findStop(route, pa.BusStopID);
                    if (!stop && !routeIsNone(routeValue)) {
                        console.warn('[WinresTransport] Could not find stop', pa.BusStopID);
                        return;
                    }
                    _this3.choices[group.index][passenger.index] = {
                        route: routeValue,
                        stop: pa.BusStopID
                    };
                });
            });

            // Restore incomplete choices not reflected in the model,
            // i.e. cases where the a route is chosen but a stop is not.
            _.forEach(oldChoices, function (group, groupIndex) {
                if (_this3.choices[groupIndex]) {
                    _.forEach(group, function (choice, passengerIndex) {
                        if (_this3.choices[groupIndex][passengerIndex] && !_this3.choices[groupIndex][passengerIndex].route && choice && choice.route && !choice.stop) {
                            // console.log('[WinresTransport] Restoring incomplete choice:',
                            // groupIndex, passengerIndex, choice.route);
                            _this3.choices[groupIndex][passengerIndex].route = choice.route;
                        }
                    });
                }
            });
        }
    }, {
        key: 'writeModel',
        value: function writeModel(passengers, groups, choices) {
            if (this.state !== 'ready') return;

            // console.log('[WinresTransport] Writing model.');

            var picks = picksFromChoices(choices, groups);

            // console.log('[WinresTransport] Picks for model:', picks);

            var picksByRoute = _.groupBy(picks, function (choice) {
                return choice.groupIndex + ' ' + choice.routeValue;
            });

            // Generate new-style product lines (accepted by Cloud as input)
            var productLines = _.map(picksByRoute, function (routePicks) {
                var sample = routePicks[0];
                var group = groups[sample.groupIndex];
                var route = findRoute(group, sample.routeValue);
                var routeCodes = routeCodesFromValue(sample.routeValue);
                if (!route) {
                    throw new Error('Selected route ' + sample.routeValue + ' not found in group:\n' + JSON.stringify(group));
                }
                var isNone = routeIsNone(sample.routeValue);

                return {
                    Amount: routePicks.length,
                    DestinationCode: routeCodes.destCode,
                    ProductCode: routeCodes.prodCode,
                    BeginDate: isNone ? null : dateOnly(route.dates.begin),
                    EndDate: isNone ? null : dateOnly(route.dates.end),
                    PassengerAssignments: _.map(routePicks, function (pick, i) {
                        return {
                            PassengerNumber: pick.passengerIndex,
                            ProductNumber: i + 1,
                            BusStopID: pick.stopID
                        };
                    }),
                    WT_RouteIsNone: routeIsNone(sample.routeValue)
                };
            });

            // console.log('[WinresTransport] Product lines:', productLines);

            // Generate old-style product lines (currently used internally by the frontend)
            var complexProductLines = _.map(productLines, function (line) {
                var routeValue = routeCodesToValue(line.DestinationCode, line.ProductCode);
                var group = _.find(groups, function (g) {
                    return _.some(g.routes, function (r) {
                        return r.value == routeValue;
                    });
                });
                var route = findRoute(group, routeValue);
                var pas = _.map(line.PassengerAssignments, function (pa) {
                    var stop = line.WT_RouteIsNone ? null : findStop(route, pa.BusStopID);
                    return {
                        PassengerNumber: pa.PassengerNumber,
                        ProductNumber: pa.ProductNumber,
                        BusStopID: pa.BusStopID,
                        // Internal use
                        Label: stop ? stop.label : '',
                        Price: stop ? stop.price : 0
                    };
                });

                return {
                    Amount: line.Amount,
                    Product: {
                        DestinationInfo: {
                            DestinationCode: line.DestinationCode,
                            ProductCode: line.ProductCode,
                            ProductName: group.label
                        },
                        BeginDate: line.BeginDate,
                        EndDate: line.EndDate,

                        // Internal use
                        Price: 0
                    },
                    PassengerAssignments: pas,
                    BusStopID: line.BusStopID,
                    PriceGroup: line.PriceGroup,
                    Route: route.label,

                    // Internal use
                    TotalPrice: _.sumBy(pas, function (pa) {
                        return pa.Price;
                    }),
                    UnitPrice: null,
                    IsTransport: true,
                    WT_RouteIsNone: line.WT_RouteIsNone
                };
            });

            // console.log('[WinresTransport] Complex product lines:', complexProductLines);

            var output = {
                valid: this.isValid(),
                productLines: productLines,
                complexProductLines: complexProductLines
            };
            // console.log('[WinresTransport] Output:', output);

            if (this.onChange) {
                this.onChange(output);
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.transportForm && this.transportForm.$valid;
        }
    }, {
        key: 'initChoices',
        value: function initChoices() {
            var _this4 = this;

            this.choices = _.map(this.groups, function (group) {
                // NOTE: This needs to be inputPassengers to make sure we have indexes for everyone
                return _.map(_this4.inputPassengers, function (passenger) {
                    return {
                        route: group.onlyRouteOption ? group.onlyRouteOption.value : null,
                        stop: null
                    };
                });
            });
        }
    }, {
        key: 'updateRouteOptions',
        value: function updateRouteOptions(passengers, groups, choices) {
            var _this5 = this;

            if (this.state !== 'ready') {
                this.routeOptions = [];
                return;
            }

            // console.log('[WinresTransport] Updating route options.');

            this.routeOptions = _.map(groups, function (group) {
                return _.map(_this5.inputPassengers, function (inputPassenger, passengerIndex) {
                    var passenger = passengers.find(function (p) {
                        return p.index === passengerIndex;
                    });
                    if (!passenger) {
                        // Passenger not found. Must be infant. No options needed.
                        return [];
                    }

                    var choice = choices[group.index][passenger.index];
                    var passengerCount = passengers.length; // Amount of relevant passengers (not infants)

                    return _.map(group.routes, function (route) {
                        var dynamicFreePlaces = routeDynamicFreePlaces(group, route, choices);
                        return {
                            value: route.value,
                            label: routeDynamicLabel(route, dynamicFreePlaces, passengerCount),
                            disabled: route.disabled || dynamicFreePlaces < 1 && choice.route !== route.value
                        };
                    });
                });
            });
        }
    }, {
        key: 'stopChoiceDisabled',
        value: function stopChoiceDisabled(group, passenger) {
            return !this.choice(group, passenger).route || this.choiceIsNone(group, passenger);
        }
    }, {
        key: 'choice',
        value: function choice(group, passenger) {
            return this.choices[group.index][passenger.index];
        }
    }, {
        key: 'choiceIsNone',
        value: function choiceIsNone(group, passenger) {
            var routeValue = this.choice(group, passenger).route;
            return routeIsNone(routeValue);
        }
    }, {
        key: 'route',
        value: function route(group, routeValue) {
            return findRoute(group, routeValue);
        }
    }, {
        key: 'stops',
        value: function stops(group, routeValue) {
            var route = this.route(group, routeValue);
            return route ? route.stops : [];
        }

        // This is to make shopping tabs know if there are any bus routes.

    }, {
        key: 'broadcastShoppingTabsStatus',
        value: function broadcastShoppingTabsStatus() {
            this.$rootScope.$broadcast('hasBusRoutes', _.some(this.groups, function (group) {
                return group.routes.length > 0;
            }));
        }
    }]);

    return winresTransportController;
}();

function routeDynamicLabel(route, dynamicFreePlaces, passengerCount) {
    if (hideFreePlaces(route, dynamicFreePlaces, passengerCount)) {
        return route.label;
    } else {
        // TODO: Translate amount of free places with $i18next
        return route.label + ' (' + Math.max(0, dynamicFreePlaces) + ' vapaana)';
    }
}

function hideFreePlaces(route, dynamicFreePlaces, passengerCount) {
    if (routeIsNone(route.value)) {
        // The none route has no concept of free places
        return true;
    } else if (dynamicFreePlaces >= passengerCount) {
        // There are enough places for everyone
        return true;
    } else {
        // There are not enough places for every passenger.
        // Display remaining count.
        return false;
    }
}

// Get the amount of free places on the route, taking into account
// any choices the user has already made.
// For example, if the backend says the route has 20 free places,
// and the user has already selected to route for one passenger,
// then return 19.
function routeDynamicFreePlaces(group, route, choices) {
    if (routeIsNone(route.value)) {
        // The none route has no concept of free places
        return 999999;
    } else {
        var alreadySelected = _.sumBy(choices[group.index], function (choice) {
            return choice.route === route.value ? 1 : 0;
        });
        return route.freePlaces - alreadySelected;
    }
}

function routeDisabled(group, passenger, route) {
    var freePlaces = this.routeFreePlaces(group, route);
    var alreadyChosen = this.choice(group, passenger).route === route.value;
    return route.disabled || freePlaces < 1 && !alreadyChosen;
}

function findRoute(group, routeValue) {
    return _.find(group.routes, function (route) {
        return route.value === routeValue;
    });
}

function findStop(route, stopID) {
    return _.find(route.stops, function (stop) {
        return stop.value === stopID;
    });
}

function routeIsNone(routeValue) {
    return routeValue === ROUTE_NONE.value;
}

// Return all valid, complete choices of transport. Ignore any invalid ones.
// Also ignore choices of no transportation (allowed for optional groups),
// since they don't result in any product lines.
// Result format:
// [
//   { groupIndex: 0, passengerIndex: 0, routeValue: 'PMMALTA 1BUS', stopID: 1001 },
//   { groupIndex: 0, passengerIndex: 1, routeValue: 'PMMALTA 1BUS', stopID: 1002 },
//   { groupIndex: 7, passengerIndex: 0, routeValue: 'PMMBUS 4BUS', stopID: 1642 },
//   ...
// ]
function picksFromChoices(choices, groups) {
    return _.flatMap(choices, function (passengerChoices, groupIndex) {
        var group = groups[groupIndex];
        if (!group) {
            throw new Error('[WinresTransport picksFromChoices] Group not found: ' + groupIndex);
        }

        return _.flatMap(passengerChoices, function (choice, passengerIndex) {
            if (choice.route && choice.stop && routeIncludesStop(group, choice.route, choice.stop)) {
                // Valid choice: route and stop
                // console.log('Group', groupIndex, 'passenger', passengerIndex,
                //             'chose route', choice.route,
                //             'and stop', choice.stop);
                return [{
                    groupIndex: groupIndex,
                    passengerIndex: passengerIndex,
                    routeValue: choice.route,
                    stopID: choice.stop
                }];
            } else if (routeIsNone(choice.route) && !choice.stop) {
                // Valid choice: nothing (optional group)
                // console.log('Group', groupIndex, 'passenger', passengerIndex,
                //             'chose no route.');
                return [{
                    groupIndex: groupIndex,
                    passengerIndex: passengerIndex,
                    routeValue: choice.route
                }];
            } else if (!choice.route && !choice.stop) {
                // No choice yet
                // console.log('Group', groupIndex, 'passenger', passengerIndex,
                //             'chose nothing yet.');
                return [];
            } else {
                // Invalid choice (e.g. route but no stop, or stop not in route)
                // console.log('Group', groupIndex, 'passenger', passengerIndex,
                //             'chose something invalid.');
                return [];
            }
        });
    });
}

function routeIncludesStop(group, routeValue, stopValue) {
    var route = findRoute(group, routeValue);
    if (!route) {
        throw new Error('[WinresTransport routeIncludesStop] Group has no route: ' + routeValue);
    }
    return !!findStop(route, stopValue);
}

function routeToOption(route) {
    var blockers = route.Blockers.length > 0 ? ' - ' + route.Blockers.join(' ') : '';
    var availableStops = _.filter(route.Stops, function (stop) {
        return stop.Blockers.length === 0;
    });
    var routeDebugInfo = route.DestCode + ' ' + route.ProdCode + ' - ';

    return {
        // label: /*routeDebugInfo + */route.Name + ' (' + route.FreePlaces + ' paikkaa)' /* + blockers */,
        label: route.Name,
        value: routeCodesToValue(route.DestCode, route.ProdCode),
        stops: _.map(availableStops, stopToOption),
        freePlaces: route.FreePlaces,
        disabled: route.Blockers.length > 0,
        dates: {
            begin: moment(route.BeginDate || route.StartDate),
            end: moment(route.EndDate)
        }
    };
}

function dateOnly(datetime) {
    return moment(datetime).format('Y-MM-DD');
}

function routeCodesToValue(destCode, prodCode) {
    return destCode + ' ' + prodCode;
}

function routeCodesFromValue(value) {
    if (value === null) {
        return null;
    }
    var parts = value.split(' ');
    if (parts.length !== 2) {
        throw new Error('Invalid route value: ' + JSON.stringify(value));
    }
    return { destCode: parts[0], prodCode: parts[1] };
}

function stopToOption(stop) {
    // const id = '[' + stop.ID + ']';
    var price = '(' + stop.Price.toFixed(2) + ' €)';
    var blockers = stop.Blockers.length > 0 ? ' - ' + stop.Blockers.join(' ') : '';
    return {
        label: /*id + ' ' +*/stop.Time + ' ' + stop.Name + ' ' + price + blockers,
        value: stop.ID,
        disabled: stop.Blockers.length > 0,
        price: stop.Price
    };
}

winresTransportController.$inject = ['$scope', '$rootScope', 'reservationService', 'cancelService'];

_module3.default.component('winresTransport', {
    template: require('./winresTransport.html'),
    controller: winresTransportController,
    bindings: {
        destCode: '@',
        beginDate: '@',
        endDate: '@',

        inputPassengers: '<passengers',
        inputProductLines: '<productLines',

        // This event is triggered with three parameters:
        //
        // valid: True if the form is valid, i.e. all required selections have been made.
        //
        // productLines: List of product lines in the new format (as passed to WRC)
        //
        // complexProductLines: List of product lines in the legacy format (as in
        //                      reservationContext.Products)
        onChange: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresTransport/winresTransport.js
// module id = 479
// module chunks = 2